import { useWeb3 } from '@/hooks'
import { supportedChains } from '@/utils'
import { ChevronDownIcon } from '@chakra-ui/icons'
import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react'
import { useSwitchChain } from 'wagmi'

export const NetworkSelector = () => {
  const { chain, isSupportedNetwork } = useWeb3()
  const { switchChain } = useSwitchChain()

  return (
    <Menu>
      <MenuButton
        isDisabled={!isSupportedNetwork}
        variant={'soft'}
        as={Button}
        rightIcon={isSupportedNetwork && <ChevronDownIcon />}
      >
        {isSupportedNetwork ? chain.name : 'Unsupported Network'}
      </MenuButton>
      <MenuList display={!isSupportedNetwork && 'none'}>
        {supportedChains.map((chain) => (
          <MenuItem
            key={chain.id}
            onClick={() => switchChain({ chainId: chain.id })}
            _focus={{ bgColor: 'primary.100' }}
          >
            {chain.name}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  )
}
